<!-- 计划任务 -->
<template>
  <div class="center">
    <div class="inline">
      <div class="box">
        <el-form ref="form" :model="form" label-width="140px">
          <div class="top">
            <strong>基础信息</strong>
          </div>
          <el-form-item label="计划名称">
            <el-input
              v-model="form.name"
              size="mini"
              class="width190"
            ></el-input>
          </el-form-item>
          <el-form-item label="计划人群">
            <el-table
              :data="tableData"
              stripe
              style="width: 380px"
              :header-cell-style="setHeader"
            >
              <el-table-column prop="name" label="人群" width="200">
              </el-table-column>
              <el-table-column prop="num" label="数量"> </el-table-column>
            </el-table>
            <div class="grey">
              每次推送人数建议少于10万，否则容易出现延时的情况
            </div>
          </el-form-item>
          <el-form-item label="计划方式">
            <div>
              <el-radio v-model="radio" label="1">自动长期计划</el-radio>
            </div>
            <div class="grey paddingleft30">
              人群中如有满足条件的新增客户，新增的客户会自动收到营销通知。长期运营计划剩余可创建9条
            </div>
            <div class="paddingleft30">
              计划执行时间：
              <el-date-picker
                v-model="value1"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                size="mini"
              >
              </el-date-picker>
            </div>
            <div>
              <el-radio v-model="radio" label="1">自动长期计划</el-radio>
            </div>
            <div class="grey paddingleft30">
              人群中如有满足条件的新增客户，新增的客户会自动收到营销通知。长期运营计划剩余可创建9条
            </div>
          </el-form-item>
          <div class="top">
            <strong>权益礼包</strong>
          </div>
          <el-form-item label="优惠券配置">
            <div>
              <el-checkbox v-model="checked"></el-checkbox
              ><span class="paddingleft6">发放优惠券</span>
            </div>
            <div class="grey paddingleft30">
              发放优惠券能有效刺激转化（优惠券将直接发放给客户，不需要领取）
            </div>
          </el-form-item>
          <div class="top">
            <strong>通知配置</strong>
          </div>
          <el-form-item label="通知渠道">
            <div class="flex">
              <div class="channel">
                <div>
                  <el-checkbox v-model="checked"></el-checkbox
                  ><span class="paddingleft6">公众号图文消息</span>
                </div>
                <div class="marginleft22">
                  <div class="grey">
                    图文消息只对有互动行为的粉丝生效，无举报风险
                  </div>
                  <div class="sign">
                    <div>未绑定认证的公众号，无法推送消息</div>
                    <div>
                      去绑定
                    </div>
                  </div>
                </div>
              </div>
              <div class="channel">
                <div>
                  <el-checkbox v-model="checked"></el-checkbox
                  ><span class="paddingleft6">短信通知</span>
                </div>
                <div class="marginleft22">
                  <div class="grey">
                    已输入123字(含签名和尾缀) 按2条短信计费
                    扣除店铺短信条数，为了发送成功，请确保在消息推送中设置了自定义签名
                  </div>
                  <div class="sign" @click="dialogFormVisible = true">
                    <div class="icon">+</div>
                    <div>
                      配置短信通知
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="">
              <el-button type="text" icon="el-icon-arrow-down">展开</el-button>
            </div>
          </el-form-item>
          <el-form-item label="通知规则">
            <div class="yellow">
              同一个客户近7天只能收到一条人群运营的微信模板消息通知
            </div>
            <div>
              <el-radio v-model="radio" label="1">仅通知一个渠道</el-radio>
            </div>
            <el-table
              :data="tableData"
              stripe
              style="width: 380px"
              :header-cell-style="setHeader"
              class="marginleft30"
            >
              <el-table-column prop="name" label="通知优先级" width="180">
              </el-table-column>
              <el-table-column prop="num" label="通知渠道"> </el-table-column>
              <el-table-column prop="num" label="排序"> </el-table-column>
            </el-table>
            <div class="grey paddingleft30">
              同一个客户仅通知优先级最高的渠道，拖拽可更改排序
            </div>
            <div>
              <el-radio v-model="radio" label="1">所有渠道同步通知</el-radio>
            </div>
            <div class="grey paddingleft30">
              同一个客户每个渠道通知一遍，有可能会骚扰客户，请慎用
            </div>
          </el-form-item>
          <div class="top">
            <strong>时间设置</strong>
          </div>
          <el-form-item label="发放权益、通知时间">
            <div>
              每天<el-time-select
                style="width: 150px; padding: 0 6px"
                v-model="value"
                size="mini"
                :picker-options="{
                  start: '08:30',
                  step: '00:15',
                  end: '18:30'
                }"
                placeholder="选择时间"
              >
              </el-time-select>
              开始发送通知
            </div>
            <div class="grey">
              为避免骚扰用户，限制通知时间范围 07:00-19:0
            </div>
          </el-form-item>
          <div class="top">
            <strong>计划异常提醒</strong>
          </div>
          <el-form-item label="提醒方式">
            <div>
              <el-checkbox v-model="checked"></el-checkbox
              ><span class="paddingleft6">通过App推送通知我</span>
            </div>
            <div>
              <el-checkbox v-model="checked"></el-checkbox
              ><span class="paddingleft6">通过短信通知我</span>
            </div>
            <div class="paddingleft30 flex">
              <div>接收通知的手机号:</div>
              <el-input
                v-model="form.name"
                size="mini"
                class="width190 paddingleft6"
              ></el-input>
              <div class="grey paddingleft6">
                为避免骚扰用户，限制通知时间范围 07:00-19:0
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="inline-bottom">
      <ul class="flex">
        <li>
          <div>计划人群：</div>
          <div>未消费新增客户</div>
        </li>
        <li>
          <div>计划人群：</div>
          <div>未消费新增客户</div>
        </li>
        <li>
          <div>计划人群：</div>
          <div>未消费新增客户</div>
        </li>
        <li>
          <el-button size="small" type="primary" style="width:100px;"
            >保存</el-button
          >
        </li>
      </ul>
    </div>
    <!-- 短信设置 -->
    <el-dialog title="短信通知" :visible.sync="dialogFormVisible" width="750px">
      <div class="edit">
        <div class="edit_left">
          <div>wefer</div>
        </div>
        <div class="edit_right">
          <el-form ref="form" :model="form" label-width="100px">
            <el-form-item label="活动名称">
              <!-- <el-input
                v-model="form.name"
                size="mini"
                class="width190"
              ></el-input> -->
              <div class="messageContent">
                <div class="top">
                  <el-button type="text" @click="dialogModule = true"
                    >选择模板</el-button
                  >
                  <el-button type="text">存为新模板</el-button>
                </div>
                <div class="middle"></div>
              </div>
              <div class="grey">短信</div>
            </el-form-item>
            <el-form-item label="活动名称">
              <div class="flex">
                <strong>hjhshjd</strong>
                <el-button type="text">修改</el-button>
                <div class="grey">(本月还能修改2次)</div>
              </div>
              <div>
                <el-checkbox v-model="checked"></el-checkbox
                ><span class="paddingleft6">同意</span>
                <el-button type="text">《短信服务协议》</el-button>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogFormVisible = false"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 模板选择弹窗 -->
    <el-dialog title="模板选择" :visible.sync="dialogModule" width="750px">
      <div class="show">
        <div class="top">
          <el-button type="primary" size="mini">节日促销</el-button>
        </div>
        <div class="list">
          <el-radio v-model="radio" label="1"
            >5.20大促0点开启，比双11更劲爆，尿不湿0-2点299-70，拉拉裤前1000名买1送1
            ，新品买3箱送1箱</el-radio
          >
          <el-radio v-model="radio" label="1"
            >5.20大促0点开启，比双11更劲爆，尿不湿0-2点299-70，拉拉裤前1000名买1送1
            ，新品买3箱送1箱</el-radio
          >
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogModule = false"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        name: ""
      },
      tableData: [
        {
          name: "未消费新增客户",
          num: "0"
        }
      ],
      dialogFormVisible: false,
      dialogModule: false,
      aaa: "ww"
    };
  },

  components: {},
  methods: {
    setHeader({ rowIndex = 0 }) {
      // 设置表头颜色
      let headerStyle = {
        //表头样式
        background: "rgba(250,250,250,1)",
        color: "#000000"
      };
      if (rowIndex === 0) {
        return headerStyle;
      } else {
        return "";
      }
    }
  }
};
</script>
<style lang="scss" scoped>
// 通用样式
strong {
  font-size: 14px;
}
.width190 {
  width: 190px;
}
.grey {
  color: #969799;
  font-size: 12px;
  line-height: 22px;
  margin: 10px 0 6px;
}
.yellow {
  margin-bottom: 5px;
  color: rgb(245, 166, 35);
}
.marginleft22 {
  margin-left: 22px;
}
.flex {
  display: flex;
}
.paddingleft6 {
  padding-left: 6px;
}
.paddingleft30 {
  padding-left: 22px;
}
.marginleft30 {
  margin-left: 22px;
}

.center {
  height: 100%;

  display: flex;
  flex-direction: column;
  .inline {
    flex: 1;
    padding: 16px;
    overflow-y: auto;
    background: #f2f2f6;
    .box {
      width: 100%;
      padding: 16px;
      background: #fff;
      .top {
        height: 30px;
        border-bottom: 1px solid #f2f2f6;
        margin-bottom: 16px;
      }
      // 通知渠道
      .channel {
        width: 294px;
        border: 1px solid #e5e5e5;
        padding: 15px;
        margin: 0 15px 15px 0;
      }
      .sign {
        border: 1px dotted #e5e5e5;
        padding: 25px 10px;
        text-align: center;
        min-height: 110px;
        box-sizing: border-box;
        font-size: 8px;
        cursor: pointer;
        .icon {
          font-size: 40px;
          line-height: 40px;
          font-weight: 200;
          color: #155bd4;
        }
      }
    }
  }
  .inline-bottom {
    width: 100%;
    background: #fff;
    height: 86px;
    border-top: 1px solid #f2f2f6;
    box-shadow: 0 -3px 5px #eee;
    ul {
      height: 100%;
      padding: 16px;
      li {
        width: 25%;
        height: 100%;
        div:nth-child(1) {
          font-weight: 550;
          height: 50%;
          font-size: 14px;
          color: #909090;
        }
      }
      li:last-child {
      }
    }
  }
}
//
// 短信通知编辑窗口
.edit {
  height: auto;
  display: flex;
  justify-content: space-between;
  .edit_left,
  .edit_right {
    width: 320px;
    height: 568px;
    background: #fff;
  }
  .edit_left {
    padding-top: 85px;
    padding-bottom: 40px;
    border: 1px solid #ccc;

    background: url("../../../../public/img/samplePhone.png");
  }
  .edit_right {
    .messageContent {
      width: 220px;
      height: 196px;
      border: 1px solid #ccc;
      padding: 0 6px;
      .top {
        border-bottom: 1px solid #ccc;
      }
    }
  }
}
// 短信模板
.show {
  width: 100%;
  height: auto;
  .top {
    padding: 16px 0;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
  }
  .list {
    width: 100%;
    > .el-radio {
      width: 100%;
      padding: 16px 0;
      border-bottom: 1px solid #ccc;
    }
  }
}
</style>
